<template>
  <v-container
      class="fill-height"
      fluid
      style="padding: 0"
  >
    <v-img
        style="height: 100%;object-fit: cover"
        :src="background"
        class="grey darken-4"
    >
      <v-dialog
          v-model="dialog"
          max-width="350"
      >
        <v-card>
          <v-card-text>
            <div v-if="error">
              Das Zertifikat konnte nicht von uns validiert werden.
            </div>
            <div v-if="validation">
              <div v-if="validation.courseName !== '-' && validation.name !== '-'">
                Der Kurs {{ validation.courseName }} wurde von {{ validation.name }} am
                {{ validation.issuedDate | moment("DD.MM.YYYY") }} erfolgreich absolviert.
              </div>
              <div v-else>
                Der Kurs wurde erfolgreich absolviert.
              </div>
              <div v-if="validation.integrityCheckAvailable && validation.integrityValid === true" style="margin-top: 12px;">
                Die hochgeladene PDF stimmt bytegenau mit dem von uns ausgestellten Original ueberein.
              </div>
              <div v-if="validation.integrityCheckAvailable && validation.integrityValid === false" style="margin-top: 12px; color: #b71c1c;">
                Die Zertifikats-ID ist gueltig, aber die hochgeladene PDF weicht vom ausgestellten Original ab.
              </div>
              <div v-if="validation.integrityCheckAvailable === false && file" style="margin-top: 12px;">
                Fuer dieses Zertifikat liegt noch kein gespeicherter Dateifingerprint vor.
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="info"
                text
                @click="dialog = false"
            >
              Schließen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="action">
        <v-sheet style="max-width: 700px" color="white" elevation="10" class="justify-center">
          <v-card-title>
            <div>
              <h3 class="headline">Behrendt Online Portal</h3>
              <div>Geben Sie hier die ID des Zertifikats ein, um dieses zu überprüfen.</div>
              <div>Optional kann die PDF hochgeladen werden, um sie gegen das ausgestellte Original zu pruefen.</div>
            </div>
          </v-card-title>
          <v-card-text>
            <v-text-field
                v-model="input"
                label="Zertifikats ID"
                required
            />
            <v-file-input
                v-model="file"
                accept=".pdf,application/pdf"
                label="PDF hochladen (optional)"
                prepend-icon="mdi-file-pdf-box"
            />
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn text color="primary" @click.stop="validate">Überprüfen</v-btn>
          </v-card-actions>
        </v-sheet>
      </div>
    </v-img>
  </v-container>
</template>

<script>
export default {
  name: "Validation",
  data() {
    return {
      background: require("@/assets/background_start.jpg"),
      input: "",
      file: null,
      dialog: false,
      error: false,
      validation: null
    }
  },
  created() {
    const { id } = this.$route.query || {};
    if (id) {
      this.input = String(id);
      this.validate();
    }
  },
  watch: {
    "$route.query.id"(id) {
      if (id) {
        const next = String(id);
        if (this.input !== next) {
          this.input = next;
        }
        this.validate();
      }
    }
  },
  methods: {
    validate() {
      const onSuccess = (data) => {
        this.validation = data;
        this.error = false;
        this.dialog = true;
      };
      const onError = () => {
        this.validation = null;
        this.error = true;
        this.dialog = true;
      };

      if (this.file) {
        this.$httpValidationApi.validateFile(this.input, this.file, onSuccess, onError);
        return;
      }

      this.$httpValidationApi.validate(this.input, onSuccess, onError)
    }
  }
}
</script>

<style scoped>
.v-parallax__image {
  transform: none !important;
  width: 100% !important;
}

.action {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
</style>
